import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "277",
  "slug": "spot-germany-from-satellite-imagery",
  "title": "How to Recognise Germany in Satellite Images",
  "excerpt": "Northern Germany belongs to a lowland region bordering the North and Baltic seas.",
  "date": "2026-04-22",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/germany.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Northern Germany belongs to a lowland region bordering the North and Baltic seas. Farther south, wooded uplands interrupt the farmland, and the Alps reach the southern border. Major rivers provide paths through these regions, including the Rhine in the west and the Elbe farther east."
    },
    {
      "type": "heading",
      "text": "The northern plain and southern uplands"
    },
    {
      "type": "paragraph",
      "text": "Compare the northern coast with the Alpine edge. A close view of a field may hide the difference, so widen the view until the regional terrain appears."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "A motorway interchange or a tiled roof is not a reliable country identifier. Poland, the Netherlands, and other neighbours share agricultural and urban patterns. Use relief and the river network to test an initial guess."
    }
  ],
  "imageAlt": "Germany regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
